import {
    AdminPanelSettingsRounded,
    AttachMoneyRounded,
    LanguageRounded,
    OpenInNewRounded,
    ReduceCapacityRounded,
} from '@mui/icons-material';
import { Button, Card, Divider, MenuItem, Select, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SettingItem from './Components/SettingItem';
import { Link } from '@tanstack/react-router';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { settingsQueryOptions } from '@utils/queryOptions';
import useApi from '@hooks/useApi';
import { useHostedPageUrls } from '@propelauth/react';

const AccountSettings = () => {
    const { t } = useTranslation();
    const { activeOrg } = useApi();

    const { getAccountPageUrl, getOrgPageUrl } = useHostedPageUrls();

    const { data: settings, refetch: refetchSettings } = useSuspenseQuery(
        settingsQueryOptions(),
    );
    const { mutate: updateSettings } = useMutation({
        mutationKey: ['updateSettings'],
        onSuccess: res => {
            refetchSettings();
        },
    });

    return (
        <Card sx={{ flex: 1 }}>
            <Stack divider={<Divider />}>
                <SettingItem
                    title={t('Language')}
                    subheader={t('settingsItem.language')}
                    Icon={LanguageRounded}
                >
                    <Select
                        size="small"
                        value={settings.language}
                        onChange={e =>
                            updateSettings({ language: e.target.value })
                        }
                    >
                        <MenuItem value="en">English</MenuItem>
                        <MenuItem value="he">עברית</MenuItem>
                    </Select>
                </SettingItem>
                {/* <SettingItem
                    title={t('Currency')}
                    subheader={t('Change your currency')}
                    Icon={AttachMoneyRounded}
                >
                    <Select size="small" value="USD" onChange={() => {}}>
                        <MenuItem value="USD">USD</MenuItem>
                        <MenuItem value="ILS">ILS</MenuItem>
                    </Select>
                </SettingItem> */}
                <SettingItem
                    title={t('Login & Security')}
                    subheader={t('settingsItem.loginSecurity')}
                    Icon={AdminPanelSettingsRounded}
                >
                    <Button
                        variant="outlined"
                        endIcon={<OpenInNewRounded />}
                        LinkComponent={Link}
                        to={getAccountPageUrl({
                            redirectBackToUrl: window.location.href,
                        })}
                        target="_blank"
                    >
                        {t('Login Settings')}
                    </Button>
                </SettingItem>
                <SettingItem
                    title={t('Team & Users')}
                    subheader={t('settingsItem.teamUsers')}
                    Icon={ReduceCapacityRounded}
                >
                    <Button
                        variant="outlined"
                        endIcon={<OpenInNewRounded />}
                        LinkComponent={Link}
                        to={getOrgPageUrl(activeOrg.orgId, {
                            redirectBackToUrl: window.location.href,
                        })}
                        target="_blank"
                    >
                        {t('Team Settings')}
                    </Button>
                </SettingItem>
            </Stack>
        </Card>
    );
};

export default AccountSettings;
